var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "@emotion/styled";
import { pxToRem } from "../ThemeProvider/typography";
import { ButtonRoot, ButtonLinkRoot, RESPONSIVE_SIZES, DEFAULT_PROPS, } from "./Button";
const actionStyles = (size) => {
    return {
        minWidth: "auto",
        padding: 0,
        height: {
            small: "32px",
            medium: "40px",
            large: "48px",
        }[size],
        width: {
            small: "32px",
            medium: "40px",
            large: "48px",
        }[size],
        "& svg, & .MuiSvgIcon-root": {
            width: "1em",
            height: "1em",
            fontSize: pxToRem({
                small: 20,
                medium: 24,
                large: 32,
            }[size]),
        },
    };
};
/**
 * A button that should contain a remixicon icon and nothing else.
 * See [ActionButton docs](https://mitodl.github.io/smoot-design/?path=/docs/smoot-design-actionbutton--docs).
 *
 * See also:
 * - [ActionButtonLink](https://mitodl.github.io/smoot-design/?path=/docs/smoot-design-actionbutton--docs#links)
 * - [Button](https://mitodl.github.io/smoot-design/?path=/docs/smoot-design-button--docs) for text buttons
 */
const ActionButton = styled(React.forwardRef(function Root(props, ref) {
    return React.createElement(ButtonRoot, Object.assign({ ref: ref, type: "button" }, props));
}))(({ size = DEFAULT_PROPS.size, responsive, theme }) => {
    return [
        actionStyles(size),
        responsive && {
            [theme.breakpoints.down("sm")]: actionStyles(RESPONSIVE_SIZES[size]),
        },
    ];
});
ActionButton.displayName = "ActionButton";
/**
 * See [ActionButtonLink docs](https://mitodl.github.io/smoot-design/?path=/docs/smoot-design-actionbutton--docs#links)
 */
const ActionButtonLink = ActionButton.withComponent((_a) => {
    var { Component } = _a, props = __rest(_a, ["Component"]);
    return React.createElement(ButtonLinkRoot, Object.assign({ Component: Component }, props));
});
ActionButtonLink.displayName = "ActionButtonLink";
export { ActionButton, ActionButtonLink, DEFAULT_PROPS };
